import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
type FlatpickrInstance = ReturnType<typeof flatpickr>;
import { Japanese } from "flatpickr/dist/l10n/ja.js";

export default class extends Controller {
  static targets = ["input", "label"];

  declare readonly inputTarget: HTMLInputElement;
  declare readonly labelTarget: HTMLSpanElement;

  private picker!: FlatpickrInstance;

  connect(): void {
    this.picker = flatpickr(this.inputTarget, {
      dateFormat: "Y-m-d",
      locale: Japanese,
      onChange: this.handleDateChange.bind(this),
      onOpen: () => {
        this.setCalendarPosition();
      },
    });
  }

  disconnect(): void {
    if (this.picker) {
      this.picker.destroy();
    }
  }

  openPicker(): void {
    this.picker.open();
  }

  private handleDateChange(_: Date[], dateStr: string): void {
    const currentUrl = new URL(window.location.href);

    currentUrl.searchParams.set("date", dateStr);

    window.location.href = currentUrl.toString();
  }

  private setCalendarPosition(): void {
    const calendar = document.querySelector(".flatpickr-calendar");
    if (calendar) {
      calendar.classList.add("custom-calendar-position");
    }
  }
}
